/**
 * Lightweight, dependency-free tracking for the catalog page only.
 * Pushes to window.dataLayer (the standard GTM/GA4 queue) if one exists on
 * the page. If no analytics tag is installed, these calls are inert no-ops —
 * they do not create or load any tracking script themselves.
 *
 * Add-to-cart, checkout, and purchase events are already captured by
 * Shopify's native Customer Events (Settings > Customer events in the
 * admin) once a pixel/GA4 is connected there — this file only covers the
 * catalog-page-specific signals Shopify can't infer on its own: which CTA
 * was clicked, and whether it was the bundle or an individual product.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'catalog_page_view',
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sc-analytics="catalog_cta_click"]');
    if (!trigger) return;

    window.dataLayer.push({
      event: 'catalog_cta_click',
      cta_type: trigger.getAttribute('data-sc-analytics-type') || 'unknown',
      product_handle: trigger.getAttribute('data-sc-analytics-handle') || '',
    });
  });
})();
